"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
var checkCardID = function checkCardID(rule, value, callback, message) {
    if (value == undefined || value == "") {
        callback();
    } else {
        if (!(value && checkIdCard(value))) {
            return callback(new Error(message));
        } else {
            callback();
        }
    }
};
function checkIdCard(idCard) {
    var idCard = idCard.replace(/ /g, ""); //去掉字符串头尾空格                                          

    var a_idCard = idCard.split(""); // 得到身份证数组   
    if (isValidityBrithBy18IdCard(idCard) && isTrueValidateCodeBy18IdCard(a_idCard)) {
        //进行18位身份证的基本验证和第18位的验证
        return true;
    } else {
        return false;
    }
}

var nonUniformLicenseCode = function nonUniformLicenseCode(rule, code, callback, message) {
    if (code.length < 15) {
        return callback(new Error(message));
    }
    var lastIndex = code.length - 1;
    var lastStr = code[lastIndex];
    var reg = /^(\d|[A-Z])$/;
    if (!reg.test(lastStr)) {
        return callback(new Error(message));
    }
    return callback();
};

var busLicenseCodeCheck = function busLicenseCodeCheck(rule, code, callback, message) {
    if (code.length != 18) {
        return callback(new Error('统一社会信用代码不少于18个字符！'));
    }
    var reg = /^([1-9ANY]{1})([123459]{1})([0-9ABCDEFGHJKLMNPQRTUWXY]{6})([0-9ABCDEFGHJKLMNPQRTUWXY]{9})([0-90-9ABCDEFGHJKLMNPQRTUWXY])$/;
    if (!reg.test(code)) {
        return callback(new Error(message));
    }
    var str = '0123456789ABCDEFGHJKLMNPQRTUWXY';
    var ws = [1, 3, 9, 27, 19, 26, 16, 17, 20, 29, 25, 13, 8, 24, 10, 30, 28];
    var codes = new Array();
    codes[0] = code.substring(0, code.length - 1); //截止最后一位
    codes[1] = code.substring(code.length - 1, code.length); //最后一位
    var sum = 0;
    for (var i = 0; i < 17; i++) {
        sum += str.indexOf(codes[0].charAt(i)) * ws[i];
    }
    var c18 = 31 - sum % 31;
    if (c18 == 31) {
        c18 = '0';
    }
    if (str.charAt(c18) != codes[1]) {
        return callback(new Error('统一社会信用代码输入有误！'));
    }
    return callback();
};

var limitedDateFun = function limitedDateFun(rule, value, callback, dateObj, message) {
    if (value == undefined || value == "") {
        callback();
    } else {
        // 默认不得小于1900年1月1日，不得大于2099年12月31日
        value = isNaN(value) && typeof value != "number" ? value : [value, value];
        if (value[0] < dateObj[0] || value[1] > dateObj[1]) {
            return callback(new Error(message));
        }
    }
    return callback();
};

// 位数限制兼容金额
var digitFn = function digitFn(rule, value, callback, bfMax, afMax, message) {
    if (value == undefined || value == "") {
        return callback();
    } else {
        var amountReg = /^((\d{1,3}(,\d{3})*(.((\d{3},)*\d{1,3}))?)|(\d+(.\d+)?))$/;
        var bfStr, afStr;
        // value = parseFloat(value.toString().replace(/,/g,"")).toString();
        value = value ? value.toString() : "0";
        value = value.replace(/,/g, "");
        if (value.indexOf(".") > 0) {
            value = value.toString().split(".");
            if (value.length != 2) {
                return callback(new Error(message));
            }
            bfStr = value[0];
            afStr = value[1];
            if (bfMax && afMax) {
                if (!amountReg.test(value) || bfStr.length > bfMax || afStr.length > afMax) {
                    return callback(new Error(message));
                }
            }
            if (bfMax) {
                if (!amountReg.test(value) || bfStr.length > bfMax) {
                    return callback(new Error(message));
                }
            }
            if (afMax) {
                if (!amountReg.test(value) || afStr.length > afMax) {
                    return callback(new Error(message));
                }
            }
        }
        if (bfMax) {
            if (!amountReg.test(value) || value.length > bfMax) {
                return callback(new Error(message));
            }
        }
        return callback();
    }
};

/**  
 * 判断身份证号码为18位时最后的验证位是否正确  
 * @param a_idCard 身份证号码数组  
 * @return  
 */
function isTrueValidateCodeBy18IdCard(a_idCard) {
    if (a_idCard.length !== 15 && a_idCard.length !== 18) {
        return false;
    }
    var Wi = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2, 1]; // 加权因子
    var ValideCode = [1, 0, 10, 9, 8, 7, 6, 5, 4, 3, 2];
    //判断最后一位是不是数字，或者是大写X
    var reg = /^(\d|X)$/;
    var lastIndex = a_idCard.length - 1;
    if (!reg.test(a_idCard[lastIndex])) {
        return false;
    }
    var sum = 0; // 声明加权求和变量   
    if (a_idCard[17] && a_idCard[17].toLowerCase() == 'x') {
        a_idCard[17] = 10; // 将最后位为x的验证码替换为10方便后续操作   
    }
    for (var i = 0; i < 17; i++) {
        sum += Wi[i] * a_idCard[i]; // 加权求和   
    }
    var valCodePosition = sum % 11; // 得到验证码所位置   
    if (a_idCard[17] && a_idCard[17] == ValideCode[valCodePosition]) {
        return true;
    } else {
        return false;
    }
}

/**  
 * 验证18位数身份证号码中的生日是否是有效生日  
 * @param idCard 18位书身份证字符串  
 * @return  
 */
function isValidityBrithBy18IdCard(idCard18) {
    var year = idCard18.substring(6, 10);
    var month = idCard18.substring(10, 12);
    var day = idCard18.substring(12, 14);
    var temp_date = new Date(year, parseFloat(month) - 1, parseFloat(day));
    // 这里用getFullYear()获取年份，避免千年虫问题   
    if (temp_date.getFullYear() != parseFloat(year) || temp_date.getMonth() != parseFloat(month) - 1 || temp_date.getDate() != parseFloat(day)) {
        return false;
    } else {
        return true;
    }
}
// 数值区间校验
function valueRangeFn(rule, value, callback, min, max, message) {
    if (typeof value != "number" && isNaN(value)) {
        //兼容千分位金额
        value = parseFloat(value.toString().replace(/,/g, "")).toString();
    }
    if (min == null) {
        if (max < value) {
            return callback(new Error(message));
        }
    }
    if (max == null) {
        if (min > value) {
            return callback(new Error(message));
        }
    }
    if (min !== null && max !== null) {
        if (min > value || max < value) {
            return callback(new Error(message));
        }
    }
    return callback();
}

// 长度校验
function lengthLimitFn(rule, value, callback, min, max, message, trigger) {
    if (!value) {
        return callback();
    }
    if (value.length > max || value.length < min) {
        return callback(new Error(message));
    }
    return callback();
}

// 位数长度限制
function bitCheckFn(rule, value, callback, digit, message, trigger) {
    if (!value) {
        return callback();
    }
    digit = digit.toString();
    if (/^.*[\,，].*$/.test(digit)) {
        digit = digit.split(",");
    } else {
        digit = [digit];
    }
    var length = value.length.toString();
    if (digit.indexOf(length) == -1) {
        return callback(new Error(message));
    }
    return callback();
}

// 数字数字组合
function onlyNumLetterFn(rule, value, callback, message, digits) {
    if (!value) {
        return callback();
    }
    var reg = /^[0-9a-zA-Z]*$/g;
    if (digits) {
        reg = eval('/^[0-9a-zA-Z]{' + digits + '}$/g');
    }
    if (!reg.test(value)) {
        return callback(new Error(message));
    }
    return callback();
}

// 数字(负数、小数位数)
function numberFn(rule, value, callback, message, dec) {
    if (!value) {
        return callback();
    }
    var reg = eval('/^([-+])?\\d+(\\.[0-9]{1,' + dec + '})?$/');
    if (!reg.test(value)) {
        return callback(new Error(message));
    }
    return callback();
}

// 大写字母+数字
function upperNumFn(rule, value, callback, message, dec) {
    if (!value) {
        return callback();
    }
    var reg = eval('/^(?=.*?[0-9])(?=.*?[A-Z])[0-9A-Z)]{1,' + dec + '}$/');
    if (!reg.test(value)) {
        return callback(new Error(message));
    }
    return callback();
}

// (中)英文加特殊字符
function charSymFn(rule, value, callback, message, locale, num) {
    if (!value) {
        return callback();
    }
    var reg = eval("/^[" + (locale ? "\\u4e00-\\u9fa5_" : "") + "a-zA-Z" + (num ? "0-9" : "") + "\\s\\\xB7\\~\\\uFF01\\@\\#\\\uFFE5\\%\\\u2026\u2026\\&\\*\\\uFF08\\\uFF09\\\u2014\u2014\\-\\+\\=\\\u3010\\\u3011\\{\\}\\\u3001\\|\\\uFF1B\\\u2018\\\u2019\\\uFF1A\\\u201C\\\u201D\\\uFF1F\\\uFF0C\\\u3002\\\u3001\\`\\~\\!\\#\\$\\%\\^\\&\\*\\(\\)\\_\\[\\]{\\}\\\\\\|\\;\\'\\'\\:\\\"\\\"\\,\\.\\/\\?]+$/");
    if (!reg.test(value)) {
        return callback(new Error(message));
    }
    return callback();
}

function rateFn(rule, value, callback, message, min, max) {
    if (!value) {
        return callback();
    }
    var reg = eval("/^[a-zA-Z0-9-+]{" + min + "," + max + "}$/");
    if (!reg.test(value)) {
        return callback(new Error(message));
    }
    return callback();
}

// 香港证件
function number_HK_fn(rule, value, callback, message, digit) {
    if (!value) {
        return callback();
    }
    var reg = eval("/^H[0-9]{" + digit + "}/");
    if (!reg.test(value)) {
        return callback(new Error(message));
    }
    return callback();
}

// 澳门证件
// 香港证件
function number_MC_fn(rule, value, callback, message, digit) {
    if (!value) {
        return callback();
    }
    var reg = eval("/^M[0-9]{" + digit + "}/");
    if (!reg.test(value)) {
        return callback(new Error(message));
    }
    return callback();
}

function userNameFn(rule, value, callback, message) {
    if (!value) {
        return callback();
    }
    var reg = /^[\u4e00-\u9fa5A-Za-z·\s（）()\-]*$/;
    if (!reg.test(value)) {
        return callback(new Error(message));
    }
    return callback();
}

exports.default = {
    // 必填校验
    required: function required() {
        var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "必填项不能为空";
        var trigger = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "blur";
        var type = arguments[2];

        return type ? { required: true, message: message, trigger: trigger, type: type } : { required: true, message: message, trigger: trigger };
    },

    // 只能输入中文
    onlyCN: function onlyCN() {
        var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '只允许输入中文';
        var trigger = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "blur";

        return { pattern: /^[\u4e00-\u9fa5]{1,}$/, message: message, trigger: trigger };
    },

    // 英文
    onlyEN: function onlyEN() {
        var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '只允许输入字母';
        var trigger = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "blur";

        return { pattern: /^[a-zA-Z]+$/, message: message, trigger: trigger };
    },

    // 只能输入中英文
    onlyCNEN: function onlyCNEN() {
        var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '只允许输入中英文字符';
        var trigger = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "blur";

        return { pattern: /^[\u4e00-\u9fa5a-zA-Z]+$/, message: message, trigger: trigger };
    },

    // 中英文和数字
    usualChar: function usualChar() {
        var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '只允许输入中英文和数字';
        var trigger = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'blur';

        return { pattern: /^[\u4E00-\u9FA5A-Za-z0-9]+$/, message: message, trigger: trigger };
    },

    // 限定特殊字符或空格
    specialContent: function specialContent() {
        var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '输入的内容可能包含特殊字符或空格';
        var trigger = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "blur";

        return { pattern: /^[\u4e00-\u9fa50-9A-Za-z-~!@#$^&-=*?]*$/, message: message, trigger: trigger };
    },

    // 仅支持数字格式
    onlyNum: function onlyNum() {
        var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '仅支持数字格式';
        var trigger = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "blur";

        return { pattern: /^[0-9]*$/, message: message, trigger: trigger };
    },

    // 仅支持数字、汉字
    onlyNumCN: function onlyNumCN() {
        var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '输入的内容仅支持数字，汉字';
        var trigger = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "blur";

        return { pattern: /^[\u4e00-\u9fa50-9]*$/, message: message, trigger: trigger };
    },

    // 仅支持数字、字母
    onlyNumLetter: function onlyNumLetter() {
        var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '输入的内容仅支持数字，字母';
        var digits = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
        var trigger = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "blur";

        return { validator: function validator(rule, value, callback) {
                onlyNumLetterFn(rule, value, callback, message, digits);
            }, trigger: trigger };
    },

    // 金额数值校验
    amount: function amount() {
        var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '金额格式有误';
        var trigger = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "blur";

        return { pattern: /^((\d{1,3}(,\d{3})*(.((\d{3},)*\d{1,3}))?)|(\d+(.\d+)?))$/, message: message, trigger: trigger };
    },

    // 只录入正数
    onlyPlus: function onlyPlus() {
        var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '数值须大于0';
        var trigger = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "blur";

        return { pattern: /^(([1-9]\d*(\.\d*[1-9])?)|(0\.\d*[1-9]))$/, message: message, trigger: trigger };
    },

    // 正整数
    integer: function integer() {
        var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '请输入正整数';
        var trigger = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "blur";

        return { pattern: /^[1-9]{1}\d*$/g, message: message, trigger: trigger };
    },

    // 不为负数
    notNegative: function notNegative() {
        var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '数值不能小于0';
        var trigger = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "blur";

        return { pattern: /^([1-9][0-9]*(\.\d{1,2})?)|(0\.\d{1,2})/, message: message, trigger: trigger };
    },

    // 长度限制
    lengthLimit: function lengthLimit() {
        var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '长度不可超过2位';
        var min = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
        var max = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 2;
        var trigger = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "blur";

        return { validator: function validator(rule, value, callback) {
                lengthLimitFn(rule, value, callback, min, max, message, trigger);
            } };
    },

    // 长度位数强校验
    bitCheck: function bitCheck() {
        var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '请输入10位字符';
        var digit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
        var trigger = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "blur";

        return { validator: function validator(rule, value, callback) {
                bitCheckFn(rule, value, callback, digit, message, trigger);
            }, trigger: trigger };
    },

    // 数值大小区间校验
    valueRange: function valueRange() {
        var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '请输入0到100的数值';
        var min = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        var max = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 100;
        var trigger = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "blur";

        return { validator: function validator(rule, value, callback) {
                valueRangeFn(rule, value, callback, min, max, message);
            }, trigger: trigger };
    },

    // 小数前后位数校验
    digit: function digit() {
        var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '小数点前至多10位，小数点后至多2位';
        var bfMax = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
        var afMax = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 2;
        var trigger = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "blur";

        return { validator: function validator(rule, value, callback) {
                digitFn(rule, value, callback, bfMax, afMax, message);
            }, trigger: trigger };
    },

    // 小数位数校验
    decimalLimit: function decimalLimit() {
        var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '最多保留两位小数';
        var min = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
        var max = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 2;
        var trigger = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "blur";

        return { pattern: eval('/^(([1-9][0-9]*)|(([0]\\.\\d{' + min + ',' + max + '}|[1-9][0-9]*\\.\\d{' + min + ',' + max + '})))$/'), message: message, trigger: trigger };
    },

    // 业绩调整-百分比
    achievementRatio: function achievementRatio() {
        var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '请输入0-100的数字(包含100)最多支持两位小数)';
        var trigger = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "blur";

        return { pattern: /^(100|[1-9]?\d(\.\d\d?)?)$/, message: message, trigger: trigger };
    },

    // 手机号
    mobile: function mobile() {
        var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '请输入正确格式的手机号';
        var trigger = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "blur";

        return { pattern: /^(1[0-9]{10})$/, message: message, trigger: trigger };
    },

    // 手机号(包含座机号)
    telephone: function telephone() {
        var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '请输入正确格式的电话';
        var trigger = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "blur";

        return { pattern: /^((0\d{2,3}-\d{7,8})|(1[0-9]{10}))$/, message: message, trigger: trigger };
    },

    // 邮箱
    email: function email() {
        var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "邮箱格式不正确";
        var trigger = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "blur";

        return { pattern: /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/, message: message, trigger: trigger };
    },

    // 不能包含空格
    space: function space() {
        var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "不能包含空格";
        var trigger = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "blur";

        return { pattern: /^[^\s]*$/, message: message, trigger: trigger };
    },

    // 新注册密码
    password_new: function password_new() {
        var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "密码由8-16位数字、字母大小写、特殊符号中的两种或两种以上组成";
        var trigger = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "blur";

        return { pattern: /(?!^(\d+|[a-zA-Z]+|[-~!@#$%^&-=*?]+)$)^[\w-~!@#$%^&-=*?]{8,16}$/, message: message, trigger: trigger };
    },

    // 登录密码(老用户可能存在6位密码)
    password_old: function password_old() {
        var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "密码由6-16位数字、字母大小写、特殊符号中的两种或两种以上组成";
        var trigger = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "blur";

        return { pattern: /(?!^(\d+|[a-zA-Z]+|[-~!@#$%^&-=*?]+)$)^[\w-~!@#$%^&-=*?]{6,16}$/, message: message, trigger: trigger };
    },

    // 中英文姓名
    name_CN_EN: function name_CN_EN() {
        var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "只允许输入中英文字符";
        var trigger = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "blur";

        return { pattern: /^[\u4e00-\u9fa5a-zA-Z\s·]+$/, message: message, trigger: trigger };
    },

    // 香港证件号
    number_HK: function number_HK() {
        var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "证件号码输入格式有误";
        var trigger = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "blur";
        var digit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 10;

        return { validator: function validator(rule, value, callback) {
                number_HK_fn(rule, value, callback, message, digit);
            }, trigger: trigger
            // return { pattern: /^H[0-9]{10}/, message, trigger}
        };
    },

    // 澳门证件号
    number_MC: function number_MC() {
        var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '证件号码输入格式有误';
        var trigger = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "blur";
        var digit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 10;

        return { validator: function validator(rule, value, callback) {
                number_MC_fn(rule, value, callback, message, digit);
            }, trigger: trigger
            // return { pattern: /^M[0-9]{10}/, message, trigger}
        };
    },

    // 身份证
    idNumber: function idNumber() {
        var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '身份证格式有误';
        var trigger = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "blur";

        return { validator: function validator(rule, value, callback) {
                checkCardID(rule, value, callback, message);
            }, trigger: trigger };
    },

    // 统一社会信用代码
    unifySocietyCode: function unifySocietyCode() {
        var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '请输入18位格式正确的信用代码';
        var trigger = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "blur";

        return { validator: function validator(rule, value, callback) {
                busLicenseCodeCheck(rule, value, callback, message);
            }, trigger: trigger };
    },

    // 税务登记证
    taxRegNumber: function taxRegNumber() {
        var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '税务登记证输入格式有误';
        var trigger = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "blur";

        // return { pattern: /^[a-zA-Z0-9-]{10,20}$/, message, trigger}
        // 2021-11-03 吴迪修改校验
        return { pattern: /^[a-zA-Z0-9-]{1,30}$/, message: message, trigger: trigger };
    },

    // 组织机构代码
    orgCode: function orgCode() {
        var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '组织机构代码输入格式有误';
        var trigger = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "blur";

        // return  { pattern: /^[a-zA-Z0-9-]{1,20}$/, message, trigger}
        // 2021-11-03 吴迪修改校验
        return { pattern: /^[a-zA-Z0-9-]{1,30}$/, message: message, trigger: trigger };
    },

    // 营业执照
    creditCode: function creditCode() {
        var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '营业执照注册号码输入格式有误';
        var trigger = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "blur";

        return { validator: function validator(rule, value, callback) {
                nonUniformLicenseCode(rule, value, callback, message);
            }, trigger: trigger };
    },

    // 法人、经办人证件号
    legalNumber: function legalNumber() {
        var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '证件号码输入格式有误';
        var trigger = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "blur";

        return { pattern: /^[a-zA-Z0-9-]{1,}$/, message: message, trigger: trigger };
    },

    // 银行账号
    bankCard: function bankCard() {
        var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '银行账号格式有误';
        var trigger = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "blur";

        return { pattern: /^[\d-]*$/, message: message, trigger: trigger };
    },

    // 承兑行、承兑人开户行行号,云商贴票据编号
    acceptorBankNumber: function acceptorBankNumber() {
        var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '请输入正确的承兑行行号(承兑行行号只能为数字)';
        var trigger = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "blur";

        return { pattern: /^\+?[1-9][0-9]*$/, message: message, trigger: trigger };
    },

    // 设置有效期限定范围
    limitedDate: function limitedDate() {
        var dateObj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [-2209017600000, 4102415999000];
        var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "不合法的日期格式或日期超出限定范围'1900/01/01-2099/12/31'！";

        return { validator: function validator(rule, value, callback) {
                limitedDateFun(rule, value, callback, dateObj, message);
            }, trigger: "change" };
    },
    notPureNumbers: function notPureNumbers() {
        var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '不能输入纯数字';
        var trigger = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "blur";
        //可以是字母，可以是数字字母，就是不能纯数字
        return { pattern: /^(?!\d+$)(?!\D+$)[\d\D]+$/, message: message, trigger: trigger };
    },

    // 数字，负数
    number: function number() {
        var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "请输入数字!";
        var dec = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
        var trigger = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "blur";

        return { validator: function validator(rule, value, callback) {
                numberFn(rule, value, callback, message, dec);
            }, trigger: trigger };
    },

    // 大写字母加数字
    upperNum: function upperNum() {
        var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "只能输入大写字母和数字!";
        var dec = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 20;
        var trigger = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "blur";

        return { validator: function validator(rule, value, callback) {
                upperNumFn(rule, value, callback, message, dec);
            }, trigger: trigger };
    },

    // 不能输入特殊字符(除了括号)
    special: function special() {
        var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "不能输入特殊字符(除了括号)!";
        var trigger = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "blur";

        return { pattern: /^[（）\(\)a-zA-Z0-9\u4e00-\u9fa5]+$/, message: message, trigger: trigger };
    },

    // (中)英文(数字)加特殊符号 locale=>true 中英文加特殊字符   false 英文加特殊字符  num 是否要数字
    charSym: function charSym() {
        var locale = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
        var num = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
        var message = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "请输入中英文数字及标点符号";
        var trigger = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "blur";

        return { validator: function validator(rule, value, callback) {
                charSymFn(rule, value, callback, message, locale, num);
            }, trigger: trigger };
    },

    // 数字、字母 + - 
    rate: function rate() {
        var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "请输入数字、字母、+或-";
        var min = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
        var max = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 3;
        var trigger = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "blur";

        return { validator: function validator(rule, value, callback) {
                rateFn(rule, value, callback, message, min, max);
            }, trigger: trigger };
    },
    onlyNumCNLetter: function onlyNumCNLetter() {
        var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "输入的内容仅支持数字，汉字，英文";
        var trigger = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "blur";

        return { pattern: /^[\u4e00-\u9fa50-9a-zA-Z]*$/, message: message, trigger: trigger };
    },

    // 用户中心姓名
    userName: function userName() {
        var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "支持输入汉字、字母、中文、·和空字符";
        var trigger = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "blur";

        return { validator: function validator(rule, value, callback) {
                userNameFn(rule, value, callback, message);
            }, trigger: trigger };
    },

    // 企业校验
    companyName: function companyName() {
        var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "请输入5-60位中英文字符、数字、罗马字符";
        var trigger = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "blur";

        return { pattern: /^[\u4e00-\u9fa5a-zA-Z0-9-\·\.\(\)\（\）\Ⅰ\Ⅱ\Ⅲ\Ⅳ\Ⅴ\Ⅵ\Ⅶ\Ⅷ\Ⅸ\Ⅹ\Ⅺ\Ⅻ]{5,60}$/, message: message };
    }
};